import { useState, useEffect } from 'react';

export const useIsOverflowHorizontal = (ref, callback) => {
  const [isOverflow, setIsOverflow] = useState(undefined);

  useEffect(
    () => {
      const { current } = ref;
      const trigger = () => {
        const hasOverflow = current.scrollWidth > current.clientWidth;

        setIsOverflow(hasOverflow);

        if (callback) callback(hasOverflow);
      };

      if (current) {
        trigger();
      }
    },
    [callback, ref.current],
  );

  return isOverflow;
};
export const useIsOverflowVertical = (ref, callback) => {
  const [isOverflow, setIsOverflow] = useState(undefined);

  useEffect(
    () => {
      const { current } = ref;

      const trigger = () => {
        const hasOverflow = current.scrollHeight > current.clientHeight;

        setIsOverflow(hasOverflow);

        if (callback) callback(hasOverflow);
      };

      if (current) {
        trigger();
      }
    },
    [callback, ref],
  );

  return isOverflow;
};

export default {};
